"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.PdfParserFinder = void 0;
var PdfParserFinder = /** @class */ (function () {
    function PdfParserFinder() {
    }
    PdfParserFinder.GetTextValue = function (text) {
        return decodeURIComponent(text.R[0].T).trim();
    };
    PdfParserFinder.GetMaxRelativeXY = function (max, xy) {
        return {
            y: (2100 * xy.y) / max.y,
            x: (1000 * xy.x) / max.x
        };
    };
    PdfParserFinder.GetMaxXY = function (json) {
        var max = { x: 0, y: 0 };
        for (var _i = 0, _a = json.pages; _i < _a.length; _i++) {
            var page = _a[_i];
            for (var _b = 0, _c = page.texts; _b < _c.length; _b++) {
                var text = _c[_b];
                if (text.x > max.x)
                    max.x = text.x;
                if (text.y > max.y)
                    max.y = text.y;
            }
        }
        return max;
    };
    PdfParserFinder.RestructureJSON = function (json) {
        var _this = this;
        if (!json || !json.formImage || json.Resturectured)
            return json;
        json.pages = json.formImage.Pages;
        for (var _i = 0, _a = json.pages; _i < _a.length; _i++) {
            var page = _a[_i];
            page.texts = page.Texts.map(function (text) {
                return {
                    x: text.x,
                    y: text.y,
                    text: _this.GetTextValue(text)
                };
            });
        }
        json.Resturectured = true;
        return json;
    };
    PdfParserFinder.FindElementByFromPage = function (page, text) {
        if (text instanceof RegExp)
            return page.texts.filter(function (item) {
                return text.test(item.text);
            });
        else
            return page.texts.filter(function (item) { return item.text == text; });
    };
    PdfParserFinder.FindRowContainingElementPage = function (page, element, displacement) {
        if (displacement === void 0) { displacement = 0.5; }
        return page.texts
            .filter(function (text) { return Math.abs(element.y - text.y) <= displacement; })
            .sort(function (a, b) { return a.x - b.x; });
    };
    PdfParserFinder.FindColumnContainingElementPage = function (page, element, displacement) {
        if (displacement === void 0) { displacement = 10; }
        return page.texts
            .filter(function (text) { return Math.abs(element.x - text.x) <= displacement; })
            .sort(function (a, b) { return a.y - b.y; });
    };
    PdfParserFinder.FindDownOfElementPage = function (page, element, displacement) {
        if (displacement === void 0) { displacement = 10; }
        var row = this.FindColumnContainingElementPage(page, element, displacement);
        var elementIndex = 0;
        for (var i = 0; i < row.length; i++) {
            var text = row[i];
            if (text.x == element.x &&
                text.y == element.y &&
                text.text == element.text) {
                elementIndex = i;
                break;
            }
        }
        return row[elementIndex + 1];
    };
    PdfParserFinder.FindUpOfElementPage = function (page, element, displacement) {
        if (displacement === void 0) { displacement = 10; }
        var row = this.FindColumnContainingElementPage(page, element, displacement);
        var elementIndex = 0;
        for (var i = 0; i < row.length; i++) {
            var text = row[i];
            if (text.x == element.x && text.y == element.y) {
                elementIndex = i;
                break;
            }
        }
        return row[elementIndex - 1];
    };
    PdfParserFinder.FindLeftOfElementPage = function (page, element, displacement) {
        if (displacement === void 0) { displacement = 0.5; }
        var row = this.FindRowContainingElementPage(page, element, displacement);
        var elementIndex = 0;
        for (var i = 0; i < row.length; i++) {
            var text = row[i];
            if (text.x == element.x && text.y == element.y) {
                elementIndex = i;
                break;
            }
        }
        return row[elementIndex - 1];
    };
    PdfParserFinder.FindRightOfElementPage = function (page, element, rightIndex, displacement) {
        if (rightIndex === void 0) { rightIndex = 1; }
        if (displacement === void 0) { displacement = 0.5; }
        var row = this.FindRowContainingElementPage(page, element, displacement);
        var elementIndex = 0;
        for (var i = 0; i < row.length; i++) {
            var text = row[i];
            if (text.x == element.x &&
                text.y == element.y &&
                text.text == element.text) {
                elementIndex = i;
                break;
            }
        }
        return row[elementIndex + rightIndex];
    };
    PdfParserFinder.FindRightOfElementUntillNumericValuePage = function (page, element, displacement) {
        if (displacement === void 0) { displacement = 0.5; }
        var row = this.FindRowContainingElementPage(page, element, displacement);
        var elementIndex = 0;
        var rightIndex = 0;
        for (var i = 0; i < row.length; i++) {
            var text = row[i];
            if (text.x == element.x && text.y == element.y) {
                elementIndex = i;
            }
            if (elementIndex) {
                rightIndex = Math.abs(i - elementIndex);
                if (rightIndex > 0 && this.GetMoneyValue(text.text)) {
                    // Check for numeric value here
                    break;
                }
            }
        }
        return row[elementIndex + rightIndex];
    };
    PdfParserFinder.FindRowOnYOfPage = function (page, y, displacement) {
        if (displacement === void 0) { displacement = 0.5; }
        var texts = page.texts.filter(function (item) { return Math.abs(y - item.y) <= displacement; });
        return texts;
    };
    PdfParserFinder.FindColumnOnXOfPage = function (page, x, displacement) {
        if (displacement === void 0) { displacement = 1; }
        var texts = page.texts.filter(function (item) { return Math.abs(x - item.x) <= displacement; });
        return texts;
    };
    PdfParserFinder.FindIntersectionNodeOfPage = function (page, element1, element2, displacementX, displacementY) {
        if (displacementX === void 0) { displacementX = 10; }
        if (displacementY === void 0) { displacementY = 10; }
        var halfDisplacementX = displacementX / 2;
        var halfDisplacementY = displacementY / 2;
        if (element1 && element2) {
            var elements = this.FindElementWithinRectOfPage(page, element1.x - halfDisplacementX, element2.y - halfDisplacementY, element1.x + halfDisplacementX, element2.y + halfDisplacementY);
            return elements[0] || null;
        }
        return null;
    };
    PdfParserFinder.FindElementWithinRectOfPage = function (page, x, y, x2, y2) {
        var texts = page.texts.filter(function (item) { return item.x >= x && item.y >= y && item.x <= x2 && item.y <= y2; });
        return texts;
    };
    PdfParserFinder.GetMoneyValue = function (str) {
        return parseFloat(str.replace(/([\$\,])/g, ""));
    };
    PdfParserFinder.MergeAllPages = function (objJSON) {
        if (!objJSON)
            throw new Error("pdf objJSON not found");
        var objMax = this.GetMaxXY(objJSON);
        var pageZero = { texts: [] };
        objJSON.pages.forEach(function (page, index) {
            var currentMaxY = index * (objMax.y + 100);
            var lstTexts = page.texts.map(function (item) {
                var newY = item.y + currentMaxY;
                return __assign(__assign({}, item), { y: newY });
            });
            pageZero.texts = pageZero.texts.concat(lstTexts);
        });
        return pageZero;
    };
    PdfParserFinder.FindRightNumericValueOfText = function (page, text, displacement) {
        if (displacement === void 0) { displacement = 2; }
        var element = this.FindElementByFromPage(page, text)[0];
        if (element) {
            var right = this.FindRightOfElementUntillNumericValuePage(page, element, displacement);
            return Number(this.GetMoneyValue(right.text));
        }
        return null;
    };
    PdfParserFinder.FindRightValueOfText = function (page, text, rightIndex, displacement) {
        if (rightIndex === void 0) { rightIndex = 1; }
        if (displacement === void 0) { displacement = 2; }
        var element = this.FindElementByFromPage(page, text)[0];
        if (element) {
            var right = this.FindRightOfElementPage(page, element, rightIndex, displacement);
            return right.text;
        }
        return null;
    };
    PdfParserFinder.FindDownValueOfText = function (page, text, displacement) {
        if (displacement === void 0) { displacement = 2; }
        var element = this.FindElementByFromPage(page, text)[0];
        if (element) {
            var down = this.FindDownOfElementPage(page, element, displacement);
            return down.text;
        }
        return null;
    };
    return PdfParserFinder;
}());
exports.PdfParserFinder = PdfParserFinder;
//# sourceMappingURL=PdfParserFinder.js.map